import { ISupplierNav } from '../../types/Supplier.types';

export const SupplierNavValues = {
    supplierNav: {
        supplierId: null,
    } as ISupplierNav,
};
